import React from "react";
import { Switch } from "react-router-dom";
import {
  DOCUMENT_PERMISSION_MASTER_ROUTE,
  DOCUMENT_PERMISSION_DETAIL_ROUTE,
  DOCUMENT_PERMISSION_HISTORY_ROUTE,
} from "config/route-consts";
import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import { authorizationService } from "services/common-services/authorization-service";
import PermissionMaster from "./PermissionMaster/PermissionMaster";
import PermissionDetail from "./PermissionDetail/PermissionDetail";
import PermissionHistoryView from "./PermissionHistory/PermissionHistoryView";

function DocumentPermissionView() {
  const { auth } = authorizationService.useAuthorizedRoute();
  return (
    <Switch>
      <ProtectedRoute
        path={DOCUMENT_PERMISSION_HISTORY_ROUTE}
        key={DOCUMENT_PERMISSION_HISTORY_ROUTE}
        component={PermissionHistoryView}
        auth={auth(DOCUMENT_PERMISSION_MASTER_ROUTE)}
      />
      <ProtectedRoute
        path={DOCUMENT_PERMISSION_DETAIL_ROUTE}
        key={DOCUMENT_PERMISSION_DETAIL_ROUTE}
        component={PermissionDetail}
        auth={auth(DOCUMENT_PERMISSION_MASTER_ROUTE)}
      />
      <ProtectedRoute
        path={DOCUMENT_PERMISSION_MASTER_ROUTE}
        key={DOCUMENT_PERMISSION_MASTER_ROUTE}
        component={PermissionMaster}
        auth={auth(DOCUMENT_PERMISSION_MASTER_ROUTE)}
      />
    </Switch>
  );
}

export { PermissionMaster };
export default DocumentPermissionView;
